export const RESET_PASSWORD_PAGE_TITLE = 'HistoWiz - Reset Password For Email';
export const RESET_PASSWORD_CONFIRM_PAGE_TITLE =
  'HistoWiz - Reset Password Confirm';
export const RESET_PASSWORD_SUCCESS_MESSAGE =
  'Account has been reset, please check your email!';
export const RESET_PASSWORD_ERROR_MESSAGE = 'Error resetting account: ';
export const RESET_PASSWORD_HELPER_TEXT =
  'Issues? Please email us at info@histowiz.com';
